import React from "react"
import PropTypes from "prop-types"
import "./StaticFilterBoxes.scss"

class StaticFilterBoxes extends React.PureComponent {
  checked = event => {
    this.props.staticFilterChange(event.target.name, event.target.checked)
  }
  render() {
    return (
      <div className="StaticFilterBoxes">
        <div className="filter-header">FILTERS</div>
        <div className="filter-option">
          <input
            type="checkbox"
            onChange={this.checked}
            name={"onlyRented"}
            id={"onlyRented"}
            checked={this.props.onlyRented}
          />
          <label htmlFor="onlyRented">Rentals only</label>
        </div>
        <div className="filter-option">
          <input
            type="checkbox"
            onChange={this.checked}
            name={"onlyStationary"}
            id={"onlyStationary"}
            checked={this.props.onlyStationary}
          />
          <label htmlFor="onlyStationary">Stationary only</label>
        </div>
      </div>
    )
  }
}

StaticFilterBoxes.propTypes = {
  staticFilterChange: PropTypes.func.isRequired,
  onlyRented: PropTypes.bool,
  onlyStationary: PropTypes.bool,
}

StaticFilterBoxes.defaultProps = {
  onlyRented: false,
  onlyStationary: false,
}

export default StaticFilterBoxes
